const mimeTypes = ["image/png"];

export function validate(file) {
  const ext = file.name.split(".").pop();
  if (file.type === "" && ext === "png") {
    return true;
  }
  if (mimeTypes.indexOf(file.type) >= 0) {
    return true;
  }
  return false;
}

export function getUploadMimeType() {
  return "image/png";
}